const UPDATE = 'pulp/showNotification/UPDATE';

export const initialState = {
  visible: false,
  hasIcon: true,
  isSemantic: true
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE:
      return {
        visible: action.visible,
        message: action.message,
        hasIcon: action.hasIcon,
        isSemantic: action.isSemantic,
      };
    default:
      return state;
  }
}

export function toggleNotification(visible, message, hasIcon = true, isSemantic = true) {
  return {
    type: UPDATE,
    visible,
    message,
    hasIcon,
    isSemantic
  };
}